import React, {Component} from "react";
import { Context } from 'context';

import styles from "./Group.module.scss";
import Expander from "components/expander/Expander";

export default class Group extends Component{
    static contextType = Context;

    moduleIsAvailable (path) {
        try {
            require.resolve(path);
            return true;
        } catch (e) {
            return false;
        }
    };

    makeSameFormatAsStyleSheet(groupName) {
        groupName = groupName.replace(/\s/g,'');
        groupName = groupName.replace('-','');
        groupName = groupName.replace('+','');
        return groupName;
    };

    render() {
        let groupName = this.props.groupName;
        const groupNameCapitalised = groupName.charAt(0).toUpperCase() + groupName.slice(1); //capitalise first letter
        if (groupName !== "ungrouped") {
            groupName = this.makeSameFormatAsStyleSheet(groupName);
            if (this.moduleIsAvailable(`images/icons/${groupName}-dark.svg`)) {
                var viewIcon = require(`images/icons/${groupName}-dark.svg`);
            } else {
                viewIcon = require(`images/icons/folder${this.context.lightTheme ? "-light" : "-dark"}.svg`);
            }
        }

        return (

            <Expander className={styles.group} closedClassName={styles.closed}>
                <div className={`${groupName} ${styles.header} highlightTertiary`}>
                    {groupName !== "ungrouped"?
                        <>
                            <img src={require(`images/icons/arrow-dark.svg`)} alt="Arrow" />
                            <img src={viewIcon} alt={groupNameCapitalised} />
                        </>
                    :
                        <>
                            <img src={require(`images/icons/arrow${this.context.lightTheme ? "-light" : "-dark"}.svg`)} alt="Arrow" />
                            <img src={require(`images/icons/folder${this.context.lightTheme ? "-light" : "-dark"}.svg`)} alt={groupNameCapitalised} />
                        </>
                    }
                    <p>{groupNameCapitalised}</p>
                </div>
                <div>
                    {this.props.children}
                </div>
            </Expander>
        );
    }

}
